import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FeatureFlagSearch, FeatureFlagSearchNames } from '../../state/models/feature-flag';
import { FeatureFlagEntityService } from '../../state/entity-services/feature-flag-entity.service';
import { LocalStoreService } from './local-store.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  featureFlagSearchNamesEnabled$: BehaviorSubject<FeatureFlagSearchNames[]> = new BehaviorSubject([]);
  featureFlagSearchNamesDisabled$: BehaviorSubject<FeatureFlagSearchNames[]> = new BehaviorSubject([]);
  featureFlagSearchNamesEnabled: FeatureFlagSearchNames[] = [];
  featureFlagSearchNamesDisabled: FeatureFlagSearchNames[] = [];

  constructor(
    private ls: LocalStoreService,
    private featureFlagEntityService: FeatureFlagEntityService) {
  }

  hasFlagEnable(permissionsNames: FeatureFlagSearchNames[]) {
    return this.featureFlagSearchNamesEnabled.some(ffName => {
      return permissionsNames.includes(ffName);
    });
  }

  setFeatureFlag(featureFlagSearch: FeatureFlagSearch) {
    this.featureFlagSearchNamesEnabled$.next(featureFlagSearch.enabledNames);
    this.featureFlagSearchNamesDisabled$.next(featureFlagSearch.disabledNames);
    this.featureFlagSearchNamesEnabled = featureFlagSearch.enabledNames;
    this.featureFlagSearchNamesDisabled = featureFlagSearch.disabledNames;
  }

  getFeatureFlagsEnabled(): FeatureFlagSearchNames[] {
    return this.featureFlagSearchNamesDisabled$.getValue() ?? [];
  }

  getFeatureFlagSearchesByOrgId(orgId?: number): Observable<FeatureFlagSearch> {
    const user = this.ls.getItem('EGRET_USER');
    if (!user) {
      return of(undefined);
    }
    const queryParams = {
      names: [
        'APP_HOME_V2',
        'APP_EXAM_COLLECTOR_OUT_DASA_NAV_PRO',
        'APP_HOME_EXAM_COLLECTOR',
        'APP_EXAM_COLLECTOR_OUT_GRUPO_FLEURY',
        'APP_EXAM_COLLECTOR_OUT_GRUPO_PARDINI',
        'PATIENT_APP_MARIA', 'PATIENT_APP_RECRUITING', 'PATIENT_APP_PATIENT_SUMMARY_V4'] as FeatureFlagSearchNames[],
      organization: orgId ? {
        id: orgId
      } : undefined,
      person: {
        id: user?.id
      },
    };
    return this.featureFlagEntityService.getFeatureFlagSearches(queryParams).pipe(
      tap((response) => {
        this.setFeatureFlag(response);
      }),
    );
  }

}
